import { TableViewData } from '../components'
import { DeviceSummaryStatus } from '../components/DeviceSummaryStatus'

export function DevicesPage() {
  // get all devices for specific user
  // get all readings for devices

  const data: TableViewData[] = [
    {
      id: 111,
      name: 'RICProto_0111',
      number: 120392121,
      site: 'Site A',
      battery: 2.91,
      datetime: 92038120,
      temperature: 21.3,
      a1: '111',
      a2: '111',
      b1: '111',
      b2: '111',
      c1: '111',
      c2: '111',
    },
    {
      id: 222,
      name: 'RICProto_0222',
      number: 120392121,
      site: 'Site B',
      battery: 3.21,
      datetime: 2921238,
      temperature: 22.3,
      a1: '222',
      a2: '222',
      b1: '222',
      b2: '222',
      c1: '222',
      c2: '222',
    },
    {
      id: 333,
      name: 'RICProto_0333',
      number: 120392121,
      site: 'Site C',
      battery: 3.31,
      datetime: 2921238,
      temperature: 20.8,
      a1: '333',
      a2: '333',
      b1: '333',
      b2: '333',
      c1: '333',
      c2: '333',
    },
  ]

  return (
    <div className={tailwind.container}>
      <h1>Remote IoAg Controllers</h1>
      <DeviceSummaryStatus data={data} />
    </div>
  )
}

const tailwind = {
  container: 'mt-3 mx-10',
}
